<ngx-spinner name='page-loader' bdColor="rgb(63,69,95)" size="medium" color="#35A291" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>
